import { render, staticRenderFns } from "./StdList.vue?vue&type=template&id=4a1c850c&"
import script from "./StdList.vue?vue&type=script&lang=js&"
export * from "./StdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports